import { MutationTree } from 'vuex'
import { VideoWidgetState } from '../types'
import setProgress from './setProgress'

const mutations: MutationTree<VideoWidgetState> = {
  setProgress,
}

export default mutations
